<template>
    <div>
        <v-card 
            elevation="0" 
            outlined 
            style="background-color: white;"
            class="ma-0 pa-0"
        >
            <v-card-text class="ma-0 pa-2">
                <v-row dense>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <slide-single :items="item.photos_total" />
                    </v-col>
                </v-row>
                <v-row dense>    
                    <v-col cols="12" md="4">
                        <v-btn
                            color="blue"
                            label
                            dark
                            small
                            block
                        >
                           {{ item.codigo }} 
                        </v-btn>  
                    </v-col> 
                    <v-col cols="12" md="7">
                        <v-btn
                            :color="item.status | statusProperty"
                            label
                            small
                            block
                            class="caption"
                        >
                            {{ item.status }}
                        </v-btn> 
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-icon left color="pink" @click="deleteItem(item.property_relation_id)">mdi-trash-can-outline</v-icon>
                    </v-col> 
                </v-row>
            </v-card-text>    
        </v-card> 
    </div>
</template>


<script>
import SlideSingle from '@/components/slideshow/SlideSingle.vue';

export default {
    components: {
        SlideSingle
    },

    computed: {
     
    }, 

    props: {
        item: {
            type: Object, // Adicione o tipo
            required: true, // Corrigido: "required" em vez de "require"
            default: () => {} // Adicione um valor padrão para arrays
        },
    },

    data () {
        return {
          
        }
    },

    methods: {
        deleteItem(id) {
            this.$emit('callDeleteItem', id);
        }
    }
}
</script>